import { QueryClient, MutationCache } from '@tanstack/react-query';
import { errorMessage } from './api/errorMessage';

/**
 * Auffangnetz für Mutationen: Wer keine eigene Fehleranzeige hat, bekommt einen Fehler-Toast —
 * ein vergessenes onError ist damit kein stiller Fehler mehr. Opt-out pro Mutation über
 * `meta: { handlesError: true }` (Rollback mit eigener Anzeige, Feldfehler am Formular).
 * Der Toast-Provider lebt im React-Baum, dieser Client außerhalb — deshalb meldet
 * `components/MutationErrorToasts.js` beim Mounten die Anzeige-Funktion hier an.
 * Für Queries kein globaler Toast: Ladefehler zeigt die Seite als Zustand.
 */
let showMutationErrorToast = null;

export function registerMutationErrorToast(fn) {
  showMutationErrorToast = fn;
  return () => { if (showMutationErrorToast === fn) showMutationErrorToast = null; };
}

export const queryClient = new QueryClient({
  mutationCache: new MutationCache({
    onError: (error, _variables, _context, mutation) => {
      if (mutation.meta?.handlesError) return;
      showMutationErrorToast?.(errorMessage(error, 'Aktion fehlgeschlagen.'));
    },
  }),
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      gcTime: 1000 * 60 * 10, // 10 minutes (formerly cacheTime)
    },
  },
});
